export const dataDebts = {
  title: "Negocie suas dívidas",
  subtitle: "Você possui uma pendência com",
  valueInitial: "value initial",
  buttonTitle: "Negocie agora",
};

export const dataCredit = {
  title: "Propostas de crédito",
  subtitle: "Encontramos uma oferta de cartão de crédito!",
  valueInitial: "Anuidade Grátis",
  valueSecondary: "Limite de",
  buttonTitle: "Ver oferta",
};
